import { render, staticRenderFns } from "./newAudition.vue?vue&type=template&id=48981586&scoped=true"
import script from "./newAudition.vue?vue&type=script&lang=js"
export * from "./newAudition.vue?vue&type=script&lang=js"
import style0 from "./newAudition.vue?vue&type=style&index=0&id=48981586&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48981586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48981586')) {
      api.createRecord('48981586', component.options)
    } else {
      api.reload('48981586', component.options)
    }
    module.hot.accept("./newAudition.vue?vue&type=template&id=48981586&scoped=true", function () {
      api.rerender('48981586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/auditionManage/newAudition.vue"
export default component.exports